<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col sm="8" lg="6">
        <v-alert border="top" colored-border elevation="5" class="ma-0">
          <h2 class="headline">
            ประกาศนัดหมาย
          </h2>
          <div class="mt-2 ml-2" v-if="student.appointments">
            <p>
              นัดบรีฟก่อนวันงาน สำหรับวันสวด :
              <strong>{{ student.appointments[0] }}</strong>
            </p>
            <p>
              นัดซ้อมพิธี 11 ธ.ค. :
              <strong>{{ student.appointments[1] }}</strong>
            </p>
            <p>
              นัดหมายวันที่ 12 ธ.ค. :
              <strong>{{ student.appointments[2] }}</strong>
            </p>
            <p>
              นัดบรีฟก่อนวันงาน สำหรับวันเผา :
              <strong>{{ student.appointments[3] }}</strong>
            </p>
            <p>
              นัดหมายวันที่ 13 ธ.ค. :
              <strong>{{ student.appointments[4] }}</strong>
            </p>
          </div>
          <p v-else>
            ไม่มีประกาศสำหรับท่าน
            <strong>กรุณาติดต่อทีมงานอาจารย์ใหญ่ทันที</strong>
          </p>
          <h2 class="headline">
            ประกาศหน้าที่ในวันที่ 12-13 ธ.ค.
          </h2>
          <p v-if="student.workPosition">
            ท่านมีตำแหน่งเป็น <em>{{ student.workPosition }}</em> ในส่วนกลาง
          </p>
          <p v-if="student.templeHead">
            ท่านเป็นเฮด<em>{{ student.templeHead.name }}</em>
          </p>
          <h3 class="title">
            วันที่ 12 ธ.ค. (วันสวดฯ)
          </h3>
          <p v-if="student.firstRole">
            {{ student.firstRole }}
            <v-btn
              v-if="firstRoleLINE"
              text
              :href="firstRoleLINE"
              v-on:click="clickFirstRoleLINE"
            >
              <img :style="{ height: '2em' }" src="../assets/LINE.png" />
            </v-btn>
          </p>
          <p v-else>-</p>
          <h3 class="title">
            วันที่ 13 ธ.ค. (วันเผาฯ)
          </h3>
          <p v-if="student.secondRole">
            {{ student.secondRole }}
            <v-btn
              v-if="secondRoleLINE"
              text
              :href="secondRoleLINE"
              v-on:click="clickSecondRoleLINE"
            >
              <img :style="{ height: '2em' }" src="../assets/LINE.png" />
            </v-btn>
          </p>
          <p v-else>-</p>
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
/* global amplitude */

export default {
  name: "RoleForm",
  props: ["student"],
  data: () => ({}),
  computed: {
    firstRoleLINE() {
      const student = this.student;
      const LINE = {
        ใบประกาศ: "http://line.me/ti/g/vHVlA-rGih",
        สถานที่: "http://line.me/ti/g/i3ZMwj3oEW",
        ปฏิคมนอก: "http://line.me/ti/g/Z6DB36U7yG",
        ปฏิคมใน: "http://line.me/ti/g/xKnDvGOZAF",
        สวัสดิการ: "http://line.me/ti/g/otUukTs81D",
      };
      if (student.firstRole) {
        return LINE[student.firstRole] || null;
      }
      return null;
    },
    secondRoleLINE() {
      const student = this.student;
      const LINE = {
        สถานที่: "http://line.me/ti/g/kuLskVZrX1",
        ปฏิคมนอก: "http://line.me/ti/g/Tmmfm5jqhM",
        ปฏิคมใน: "http://line.me/ti/g/oRtP7EF5bX",
        สวัสดิการ: "http://line.me/ti/g/7oG-UQfGPe",
      };
      if (student.secondRole) {
        return LINE[student.secondRole] || null;
      }
      return null;
    },
  },
  methods: {
    clickFirstRoleLINE() {
      amplitude.getInstance().logEvent("click-LINE", {
        type: "firstRole",
        value: this.student.firstRole,
      });
    },
    clickSecondRoleLINE() {
      amplitude.getInstance().logEvent("click-LINE", {
        type: "secondRole",
        value: this.student.secondRole,
      });
    },
  },
};
</script>
